import React, { useState } from "react";
import { UserPlus, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

// Owner invites other users (by email) to view and comment on the project.
export function ShareDialog({ open, onOpenChange, projectId, shared, onChange, t }) {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const invite = async () => {
        const v = email.trim();
        if (!v) return;
        setBusy(true);
        try {
            const { data } = await api.post(`/projects/${projectId}/share`, { email: v });
            onChange(data.shared_emails);
            setEmail("");
            toast.success(t("sh_invited", { e: v }));
        } catch (e) {
            toast.error(formatApiErrorDetail(e.response?.data?.detail) || t("sh_error"));
        } finally { setBusy(false); }
    };
    const remove = async (e) => {
        try {
            const { data } = await api.delete(`/projects/${projectId}/share/${encodeURIComponent(e)}`);
            onChange(data.shared_emails);
        } catch { toast.error(t("sh_error")); }
    };
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent data-testid="share-dialog" className="bg-[#111827] border-[#1e293b] text-slate-100">
                <DialogHeader>
                    <DialogTitle>{t("sh_title")}</DialogTitle>
                    <DialogDescription className="text-slate-400">{t("sh_desc")}</DialogDescription>
                </DialogHeader>
                <div className="flex gap-2">
                    <input data-testid="share-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                        onKeyDown={(e) => { if (e.key === "Enter") invite(); }} placeholder={t("sh_email_ph")}
                        className="flex-1 bg-[#0b0f17] border border-[#1e293b] rounded-md text-sm px-3 py-2 focus:outline-none focus:ring-1 focus:ring-blue-500/60" />
                    <button data-testid="share-invite-btn" onClick={invite} disabled={busy}
                        className="inline-flex items-center gap-1.5 px-3 rounded-md bg-blue-600 hover:bg-blue-500 text-sm font-medium disabled:opacity-60">
                        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <UserPlus className="w-4 h-4" />} {t("sh_invite")}
                    </button>
                </div>
                <div className="space-y-1.5 max-h-60 overflow-auto">
                    {(shared || []).length === 0 && <p className="text-sm text-slate-500">{t("sh_none")}</p>}
                    {(shared || []).map((e) => (
                        <div key={e} data-testid={`share-item-${e}`} className="flex items-center justify-between rounded-md border border-[#1e293b] bg-[#0b0f17] px-3 py-1.5 text-sm">
                            <span className="truncate">{e}</span>
                            <button data-testid={`share-remove-${e}`} onClick={() => remove(e)} title={t("sh_remove")}
                                className="text-slate-500 hover:text-rose-400 p-1"><X className="w-3.5 h-3.5" /></button>
                        </div>
                    ))}
                </div>
            </DialogContent>
        </Dialog>
    );
}
